import { render, staticRenderFns } from "./ChangeDateDialog.vue?vue&type=template&id=515c63e0&"
import script from "./ChangeDateDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeDateDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports